module.exports = __webpack_public_path__ + "static/img/wegovy3.ee582f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c25/wegovy3.png
// module id = itaF
// module chunks = 1